import { render, staticRenderFns } from "./NearestArrival.vue?vue&type=template&id=4730daab&scoped=true&"
import script from "./NearestArrival.vue?vue&type=script&lang=js&"
export * from "./NearestArrival.vue?vue&type=script&lang=js&"
import style0 from "./NearestArrival.vue?vue&type=style&index=0&id=4730daab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4730daab",
  null
  
)

component.options.__file = "NearestArrival.vue"
export default component.exports